/** 协议弹窗：moduleID */
export const TP_CREDIT_AGREEMENTS_READ_POP_MODULE = 'finance_loan_creditAgreementsReadPopUp';
